import gql from 'graphql-tag'
import {useQuery} from '@apollo/client'
import {useGetFiltersData} from './getFiltersData'

const personaEngagementQuery = gql`
  query personaEngagement($filters: Filters, $persona: String!, $benefits: [BenefitEligibility]) {
    personaEngagement(filters: $filters, persona: $persona, benefits: $benefits) {
      unemploymentRisk
      uninsuranceRisk
      hospitalAccess
      pharmacyAccess
      transportationInsecurity
    }
  }
`

export default function PersonaEngagement() {
  const {filtersData, personaSidebarOpen, benefitsData} = useGetFiltersData()

  const {
    data: personaEngagement,
    loading: loadingPersonaEngagement,
    refetch: refetchPersonaEngagement,
    error: errorLoadingPersonaEngagement
  } = useQuery(personaEngagementQuery, {
    variables: {
      filters: filtersData,
      persona: personaSidebarOpen?.name,
      benefits: benefitsData[0]
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })
  return {personaEngagement, loadingPersonaEngagement, refetchPersonaEngagement, errorLoadingPersonaEngagement}
}
